var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('b-modal', {
    ref: "modal",
    attrs: {
      "title": "Selecione a embalagem",
      "centered": "",
      "size": "lg",
      "no-close-on-backdrop": ""
    },
    on: {
      "shown": _vm.aoAbrir,
      "hidden": _vm.aoFechar
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn() {
        return [_c('b-button', {
          attrs: {
            "variant": "secondary"
          },
          on: {
            "click": _vm.cancelar
          }
        }, [_vm._v("Cancelar")]), _c('b-button', {
          attrs: {
            "variant": "primary",
            "disabled": !_vm.embalagemSelecionada
          },
          on: {
            "click": _vm.confirmar
          }
        }, [_vm._v(" Usar embalagem ")])];
      },
      proxy: true
    }])
  }, [_c('p', {
    staticClass: "mb-4"
  }, [_vm._v(" Escolha como "), _c('strong', [_vm._v(_vm._s(_vm.produto.descricao))]), _vm._v(" será vendido. ")]), _c('b-list-group', _vm._l(_vm.embalagens, function (embalagem) {
    return _c('b-list-group-item', {
      key: embalagem.id_produto_embalagem,
      ref: "itensEmbalagem",
      refInFor: true,
      staticClass: "embalagem-item",
      class: {
        'embalagem-item-sem-quantidade': !_vm.permitirQuantidade
      },
      attrs: {
        "active": _vm.idSelecionado === embalagem.id_produto_embalagem
      },
      on: {
        "click": function click($event) {
          return _vm.selecionar(embalagem);
        },
        "dblclick": _vm.confirmar
      }
    }, [_c('div', {
      staticClass: "embalagem-info"
    }, [_c('strong', [_vm._v(_vm._s(_vm.descricaoUnidade(embalagem)))]), embalagem.embalagem_padrao ? _c('span', {
      staticClass: "badge badge-light ml-2"
    }, [_vm._v(" Padrão ")]) : _vm._e(), _c('span', {
      staticClass: "d-block small",
      class: _vm.idSelecionado === embalagem.id_produto_embalagem ? 'text-white' : 'text-muted'
    }, [_vm._v(" Baixa " + _vm._s(_vm.formatarQuantidade(embalagem.fator_conversao * _vm.quantidadeDaEmbalagem(embalagem))) + " " + _vm._s(_vm.descricaoUnidadeBase) + " do estoque "), embalagem.cod_barras ? [_vm._v(" · Cód. barras: " + _vm._s(embalagem.cod_barras) + " ")] : _vm._e()], 2)]), _vm.permitirQuantidade ? _c('div', {
      staticClass: "quantidade-embalagem",
      on: {
        "click": function click($event) {
          $event.stopPropagation();
        },
        "dblclick": function dblclick($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "light"
      },
      on: {
        "click": function click($event) {
          return _vm.diminuirQuantidade(embalagem);
        }
      }
    }, [_vm._v(" - ")]), _c('b-form-input', {
      ref: "inputsQuantidade",
      refInFor: true,
      staticClass: "text-center quantidade-input",
      attrs: {
        "type": "number",
        "min": "1",
        "value": _vm.quantidadeDaEmbalagem(embalagem)
      },
      on: {
        "input": function input($event) {
          return _vm.alterarQuantidade(embalagem, $event);
        },
        "focus": function focus($event) {
          return _vm.selecionar(embalagem);
        }
      }
    }), _c('b-button', {
      attrs: {
        "size": "sm",
        "variant": "light"
      },
      on: {
        "click": function click($event) {
          return _vm.aumentarQuantidade(embalagem);
        }
      }
    }, [_vm._v(" + ")])], 1) : _vm._e(), _c('strong', {
      staticClass: "font-size-lg embalagem-total"
    }, [_vm._v(" " + _vm._s(_vm.formatarMoeda(embalagem.preco * (_vm.permitirQuantidade ? _vm.quantidadeDaEmbalagem(embalagem) : 1))) + " ")])]);
  }), 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };